import { render, staticRenderFns } from "./DrawerSoc.vue?vue&type=template&id=81422640&scoped=true"
import script from "./DrawerSoc.vue?vue&type=script&lang=js"
export * from "./DrawerSoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81422640",
  null
  
)

export default component.exports